// @ts-check

import React from 'react';
import Button from '@material-ui/core/Button';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import Dialog from '@material-ui/core/Dialog';
import MenuItem from '@material-ui/core/MenuItem';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { useDispatch, useSelector } from 'react-redux';
import WebappClientConnect from '../Query/webAppClientComponent'
import { USER_FORM_DELAY_MS } from '../common/constants'

import {
  SET_USER_DATA,
  SET_USER_IS_REGISTERED
} from '../../redux/actions/actionTypes'

const _webappClient = new WebappClientConnect.WrappedComponent()

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  }
}));

let authStateTimer = null
const deferUserFormPopupIfNeeded = (authState, topLevelState, setOpenFunc) => {
  if (!authStateTimer && !authState.isUserRegistered && topLevelState.plooto_queries_count >= 2) {
    authStateTimer = setTimeout(() => {
      setOpenFunc(true)
    }, USER_FORM_DELAY_MS)
  } 
}

// TODO: test this form in incognito for now
export default function NewUserForm() {
  const authState = useSelector(state => state.auth);
  const topLevelState = useSelector(state => state.topLevel);
  const dispatch = useDispatch()
  const classes = useStyles()

  const [open, setOpen] = React.useState(false);
  deferUserFormPopupIfNeeded(authState, topLevelState, setOpen)
  // const handleClickOpen = () => {
  //   setOpen(true);
  // };

  const createUser = async () => {
    const userData = {
      profession: authState?.userData?.profession,
      industry: authState?.userData?.industry,
      companyEmployeesNum: authState?.userData?.companyEmployeesNum,
      futureWorkSuggestion: authState?.userData?.futureWorkSuggestion,
      email: authState?.userData?.email
    }
    const userId = authState?.user?.uid
    if (!userId) {
      throw new Error('no user id')
    }
    const res = await _webappClient.createUser(`basic ${userId}`, userData)
    
    if(res.status === 200){
      dispatch({
        type: SET_USER_IS_REGISTERED,
        payload: true
      })
      setOpen(false)
    }
  }

  return (
    <Dialog
      open={open}
      // onClose={}
      aria-labelledby="form-dialog-title">
      <DialogTitle>Hello new user. Before we continue plesae tell us about yourself</DialogTitle>

      <FormControl className={classes.formControl}>
        <InputLabel>I am a</InputLabel>

        <Select
          native
          value={authState?.userData?.profession}

          onChange={(event) => {
            dispatch({
              type: SET_USER_DATA,
              payload: {
                field: 'profession',
                value: event.target.value
              }
            })
          }}
        >
          <option aria-label="None" value="" />
          <option value={'Academic'}>Academic</option>
          <option value={'Architect_or_designer'}>Architect / Designer</option>
          <option value={'Environmental_analyst'}>Environmental analyst</option>
          <option value={'Investment_analyst'}>Investment analyst</option>
          <option value={'Environmental_analyst'}>Environmental analyst</option>
          <option value={'Real-estate_developer'}>Real-estate developer</option>
          <option value={'Student'}>Student</option>
          <option value={'Other'}>Other</option>
        </Select>

        {authState?.userData?.profession === 'Other' &&
          <TextField
            autoFocus
            margin="dense"
            id="professionFreeText"
            label="Please specify your profession"
            type="string"
            fullWidth
            value={authState?.userData?.professionFreeText}
            onChange={(event) => {
              dispatch({
                type: SET_USER_DATA,
                payload: {
                  field: 'professionFreeText',
                  value: event.target.value
                }
              })
            }}
          />
        }

      </FormControl>

      <FormControl className={classes.formControl}>
        <InputLabel>I work in</InputLabel>

        <Select
          native
          value={authState?.userData?.industry}

          onChange={(event) => {
            dispatch({
              type: SET_USER_DATA,
              payload: {
                field: 'industry',
                value: event.target.value
              }
            })
          }}
        >
          <option aria-label="None" value="" />
          <option value={'Architecture_or_planning_or_design'}>Architecture / Urban planning / Design</option>
          <option value={'Environmental_consultancy'}>Environmental consultancy</option>
          <option value={'Govermental_or_local_authority'}>Governmental / Local authority</option>
          <option value={'Real_estate_development'}>Real-estate development</option>
          <option value={'Other'}>Other</option>
        </Select>

        {authState?.userData?.industry === 'Other' &&
          <TextField
            autoFocus
            margin="dense"
            id="industryFreeText"
            label="Please specify the industry you're in"
            type="string"
            fullWidth
            value={authState?.userData?.industryFreeText}
            onChange={(event) => {
              dispatch({
                type: SET_USER_DATA,
                payload: {
                  field: 'industryFreeText',
                  value: event.target.value
                }
              })
            }}
          />
        }
      </FormControl>

      <FormControl className={classes.formControl}>
        <InputLabel>The number of employees in the company I work in is around</InputLabel>

        <Select
          native
          value={authState?.userData?.companyEmployeesNum}

          onChange={(event) => {
            dispatch({
              type: SET_USER_DATA,
              payload: {
                field: 'companyEmployeesNum',
                value: event.target.value
              }
            })
          }}
        >
          <option aria-label="None" value="" />
          <option value={10}>1-10</option>
          <option value={50}>10-50</option>
          <option value={100}>50-100</option>
          <option value={250}>100-250</option>
          <option value={1000}>250-1000</option>
          <option value={5000}>More than 1000</option>
        </Select>
      </FormControl>

      <FormControl className={classes.formControl}>
        <TextField
          autoFocus
          margin="dense"
          id="future_work"
          label="What would you like Plooto to do in the future?"
          type="string"
          fullWidth
          value={authState?.userData?.futureWorkSuggestion}
          onChange={(event) => {
            dispatch({
              type: SET_USER_DATA,
              payload: {
                field: 'futureWorkSuggestion',
                value: event.target.value
              }
            })
          }}

        />
      </FormControl>

      <FormControl className={classes.formControl}>
        <TextField
          autoFocus
          margin="dense"
          id="email"
          label="What is your Email? We will not spam you, we promise :)"
          type="email"
          fullWidth
          value={authState?.userData?.email}
          onChange={(event) => {
            dispatch({
              type: SET_USER_DATA,
              payload: {
                field: 'email',
                value: event.target.value
              }
            })
          }}
        />
      </FormControl>

      <DialogActions>
        <Button onClick={createUser} color="primary">
          Send
        </Button>
      </DialogActions>
    </Dialog>
  );
}
